import { ICostAnalysisState } from '@/modules/costAnalysis/store/state';
import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import {
  AllAnalysisData,
  AnalysisPensionScheme,
  AnalysisFunds,
  FundAnalysisData,
  FundCost,
  AppliedAnalysisFilter,
  PaginationMeta,
  Paginated
} from '../types';
import Organisation from '../../../models/Organisation';
import OrganisationType from '../../../models/OrganisationType';
import TimePeriod from '../../../models/TimePeriod';
import { SubFund } from '../../subFund/types';
import { Fund, OrganisationManager } from '../../fund/types';
/**
 * --------------------------------------------------
 *	Cost Analysis Getters
 * --------------------------------------------------
 **/
export const CostAnalysisGetters: ICostAnalysisGetters = {
  fetchingData: (state: ICostAnalysisState): boolean => state.fetchingData,
  analysisData: (state: ICostAnalysisState): AllAnalysisData =>
    state.analysisData,
  fundAnalysisData: (state: ICostAnalysisState): FundAnalysisData =>
    state.fundAnalysisData,
  paginatedFundAnalysis: (state: ICostAnalysisState): FundCost[] =>
    state.paginatedFundAnalysis,
  analysisPaginationMeta: (state: ICostAnalysisState): PaginationMeta =>
    state.analysisPaginationMeta,
  paginatedFunds: (state: ICostAnalysisState): Paginated<Fund> =>
    state.paginatedFunds,
  allAssetClasses: (state: ICostAnalysisState): OrganisationType[] =>
    state.allAssetClasses,
  allTimePeriods: (state: ICostAnalysisState): TimePeriod[] =>
    state.allTimePeriods,
  allOrganisationTypes: (state: ICostAnalysisState): OrganisationType[] =>
    state.allOrganisationTypes,
  allAssetManagers: (state: ICostAnalysisState): OrganisationManager[] =>
    state.allAssetManagers,
  allFunds: (state: ICostAnalysisState): AnalysisFunds[] => state.allFunds,
  allExposedFunds: (state: ICostAnalysisState): AnalysisFunds[] =>
    state.allExposedFunds,
  allExposedPensionSchemes: (
    state: ICostAnalysisState
  ): AnalysisPensionScheme[] => state.allExposedPensionSchemes,
  appliedAllAnalysisFilter: (
    state: ICostAnalysisState
  ): AppliedAnalysisFilter => state.appliedAllAnalysisFilter,
  filterFunds: (state: ICostAnalysisState): AnalysisFunds[] =>
    state.filterFunds,
  filterPensionSchemes: (state: ICostAnalysisState): AnalysisPensionScheme[] =>
    state.filterPensionSchemes,
  filterSubFunds: (state: ICostAnalysisState): SubFund[] =>
    state.filterSubFunds,
  filterAssetClasses: (state: ICostAnalysisState): any =>
    state.filterAssetClasses,
  filterTimePeriods: (state: ICostAnalysisState): any =>
    state.filterTimePeriods,
  currentOrganisation: (state: ICostAnalysisState): Organisation =>
    state.currentOrganisation
};

/**
 * --------------------------------------------------
 *	Cost Analysis Getters Interface
 * --------------------------------------------------
 **/
export interface ICostAnalysisGetters
  extends GetterTree<ICostAnalysisState, IRootState> {
  fetchingData(state: ICostAnalysisState): boolean;
  analysisData(state: ICostAnalysisState): AllAnalysisData;
  fundAnalysisData(state: ICostAnalysisState): FundAnalysisData;
  paginatedFundAnalysis(state: ICostAnalysisState): FundCost[];
  analysisPaginationMeta(state: ICostAnalysisState): PaginationMeta;
  paginatedFunds(state: ICostAnalysisState): Paginated<Fund>;
  allAssetClasses(state: ICostAnalysisState): OrganisationType[];
  allTimePeriods(state: ICostAnalysisState): TimePeriod[];
  allOrganisationTypes(state: ICostAnalysisState): OrganisationType[];
  allAssetManagers(state: ICostAnalysisState): OrganisationManager[];
  allFunds(state: ICostAnalysisState): AnalysisFunds[];
  allExposedFunds(state: ICostAnalysisState): AnalysisFunds[];
  allExposedPensionSchemes(state: ICostAnalysisState): AnalysisPensionScheme[];
  appliedAllAnalysisFilter(state: ICostAnalysisState): AppliedAnalysisFilter;
  filterFunds(state: ICostAnalysisState): AnalysisFunds[];
  filterPensionSchemes(state: ICostAnalysisState): AnalysisPensionScheme[];
  filterAssetClasses(state: ICostAnalysisState): OrganisationType[];
  filterTimePeriods(state: ICostAnalysisState): TimePeriod[];
  currentOrganisation(state: ICostAnalysisState): Organisation;
}
